export default {
      id: "ic-misc-print-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-print-usage",
      toString: function () {
        return this.url;
      }
    }